module.exports = __webpack_public_path__ + "static/media/internetMoney.b042f032.svg";